import type { PaymentResult } from '@optionway/models';

interface PaymentResultStore {
  result?: PaymentResult;
}

export const usePaymentResultStore = defineStore('payment-result', {
  state: (): PaymentResultStore => ({
    result: undefined,
  }),
});
